<template>
  <div />
</template>

<script>
export default {
  name: 'AccountChange',
  created() {
    this.$router.push('/');
  },
};
</script>
